import { Box } from "@outschool/backpack";
import { useSession } from "@outschool/ui-auth";
import React from "react";

import { SelectedLearner } from "../chatProvider";
import { ChatInputSelection } from "./ChatInputSelection";

type LearnerSelectionProps = {
  label: string;
  selectedLearner?: SelectedLearner | null;
  onLearnerSelect: (learner: SelectedLearner) => void;
  color?: "primary" | "neutral";
};
export const LearnerSelection = ({
  label,
  selectedLearner,
  onLearnerSelect,
  color = "primary"
}: LearnerSelectionProps) => {
  const { currentUser } = useSession();
  const learners = currentUser?.children;

  return (
    <>
      {!!learners?.length ? (
        <Box
          sx={{
            "& .MuiButton-root": {
              borderColor: color === "primary" ? "primary.main" : "neutral.300",
              color: color === "primary" ? "primary.main" : "grey.900"
            }
          }}
        >
          <ChatInputSelection
            label={label}
            options={learners}
            optionLabel={`name`}
            selectedOption={selectedLearner}
            onSelect={(learner: SelectedLearner) => onLearnerSelect(learner)}
            clearable
          />
        </Box>
      ) : null}
    </>
  );
};
